<div class="row rounded-card">
  <div class="flex flex-wrap justify-between items-end mb-4" id="setting-view-header-wr">
    <div class="flex flex-col">
      <h2 data-testid="machine-client-title">Branding settings</h2>
      <span class="text-base">Customise the portal and digital card look and feel</span>
    </div>

    <div class="flex items-center gap-2"></div>
  </div>

  <hr class="mb-1 mt-2 border-t">

  <p-tabs [value]="activeTabIndex" (valueChange)="onTabChange($event)">

    <p-tablist>
      <p-tab [value]="0">
        {{ 'SYSTEM_SETTINGS.TABS.THEME' | translate }}
      </p-tab>
    </p-tablist>

    <p-tabpanels>
      <p-tabpanel [value]="0">
        @if (activeTabIndex === 0) {
          <app-theme-settings></app-theme-settings>
        }
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
